import type { TFunction } from "i18next";
import { z } from "zod";

export const MAX_TEXT_LENGTH = 500;

export const rejectLicenseSchema = (t: TFunction) =>
  z.object({
    rejectionNotes: z
      .string()
      .trim()
      .max(
        MAX_TEXT_LENGTH,
        t("licensing.form-validation.max-length", {
          label: t("licensing.notes"),
          max: MAX_TEXT_LENGTH,
        }),
      )
      .min(
        1,
        t("licensing.form-validation.mandatory", {
          label: t("licensing.notes"),
        }),
      ),
  });

export type RejectLicenseSchema = z.infer<ReturnType<typeof rejectLicenseSchema>>;
